import React, { useState, useEffect, useCallback } from "react";
import ClubData from "data/Clubs.json";
import Tnc from "components/tnc/Tnc";

const getClubDataByTitle = (club_title) => {
  if (!club_title) return null;
  const club = ClubData.find((item) => item.title === club_title);
  if (club.prize_pool && club.contacts) return club;
  return null;
};

export default function ClubDetails({ selectedClub }) {
  const data = getClubDataByTitle(selectedClub);

  if (!data) {
    return "";
  }

  return (
    <div className="text-white bg-black/80 w-full px-8 py-2 flex justify-between items-center club_details">
      <div className="font-black-hawk text-3xl">
        <span>
          <span>Priz</span>
          <span className="text-red">e Po</span>
          <span>ol : </span>
        </span>
        <span className="text-5xl">
          <Counter finalValue={parseInt(data.prize_pool.split(" ")[0])} />

          <span className="text-red">
            {data.prize_pool.split(" ")[1].slice(0, 2)}
          </span>
          <span className="text-red">
            {data.prize_pool.split(" ")[1].slice(2)}
          </span>
        </span>
      </div>
      <div className="flex club_details_contact">
        {data.contacts.map((item, _idx) => {
          return (
            <div key={_idx.toString()} className="px-2 text-center">
              <span className="text-red font-bold">{item.name + " : "}</span>
              <a href={"tel:" + item.number.replaceAll("-", "")}>
                {item.number}
              </a>
            </div>
          );
        })}
        <Tnc />
      </div>
    </div>
  );
}

const Counter = ({ finalValue }) => {
  const [value, setValue] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const ref = useCallback((node) => {
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          setIsVisible(true);
        }
      },
      {
        rootMargin: "0px",
        threshold: 0.2,
      }
    );

    observer.observe(node);
  }, []);

  useEffect(() => {
    let timer = null;
    if (isVisible) {
      timer = setInterval(() => {
        setValue((cur) => {
          if (cur >= finalValue) {
            clearInterval(timer);
            return finalValue;
          }

          return Math.ceil(cur + finalValue * 0.1);
        });
      }, 150);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [finalValue, isVisible]);

  return <span ref={ref}>{value}</span>;
};
